(() => {
  const initFaq = (root = document) => {
    root.querySelectorAll('[data-yc-faq-button]').forEach((button) => {
      if (button.dataset.ycReady === 'true') return;
      button.dataset.ycReady = 'true';
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
        const symbol = button.querySelector('.yc-faq__symbol');
        if (symbol) symbol.textContent = expanded ? '+' : '−';
      });
    });
  };
  initFaq();
  document.addEventListener('shopify:section:load', (event) => initFaq(event.target));
})();
